import { api } from '@/api'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import type { LeaderboardRanking, LeaderboardResponse } from './models'

export const useLeaderboard = ({ page, limit }: { page: number; limit: number }) => {
  return useQuery({
    queryKey: ['LEADERBOARD', page, limit],
    queryFn: () => api.get<LeaderboardResponse>('/leaderboard', { params: { page, limit } }),
    placeholderData: keepPreviousData,
    staleTime: 30_000
  })
}

export const useLeaderboardRanking = () => {
  return useQuery({
    queryKey: ['LEADERBOARD_RANKING'],
    queryFn: () => api.get<LeaderboardRanking>('/leaderboard/rank')
  })
}
